import { TableRow } from '@mui/material';
import { styled } from '@mui/system';

const FlexTableRow = styled(TableRow)`
  width: 100%;
  display: flex;
`;
export default FlexTableRow;
